import React from 'react';
import PropTypes from 'prop-types';
import { passengersShape, legShape } from 'constants/propTypes';
import { isABSOrADSFirstLeg } from '../JourneyDigest.utils';

import JourneyDetails from '../JourneyDetails';
import JourneyDetailsAddOns from '../JourneyDetailsAddOns';

const JourneyDetailsWithABSADS = ({
  journey,
  paxDetails,
  direction,
  currency,
  originUIC,
  destinationUIC,
  passengers,
  infantCount,
  isLoyaltyBooking = false
}) => {
  const shouldDisplayAddOnsLegsFirst = isABSOrADSFirstLeg(direction, originUIC, destinationUIC);

  return (
    <>
      {shouldDisplayAddOnsLegsFirst ? (
        <>
          <JourneyDetailsAddOns
            journey={journey}
            direction={direction}
            currency={currency}
            originUIC={originUIC}
            destinationUIC={destinationUIC}
            passengers={passengers}
            shouldDisplayAddOnsLegsFirst
            infantCount={infantCount}
            isLoyaltyBooking={isLoyaltyBooking}
          />

          <JourneyDetails
            journey={journey}
            paxDetails={paxDetails}
            direction={direction}
            currency={currency}
            infantCount={infantCount}
            isLoyaltyBooking={isLoyaltyBooking}
          />
        </>
      ) : (
        <>
          <JourneyDetails
            journey={journey}
            paxDetails={paxDetails}
            direction={direction}
            currency={currency}
            infantCount={infantCount}
            isLoyaltyBooking={isLoyaltyBooking}
          />

          <JourneyDetailsAddOns
            journey={journey}
            direction={direction}
            currency={currency}
            originUIC={originUIC}
            destinationUIC={destinationUIC}
            passengers={passengers}
            infantCount={infantCount}
            isLoyaltyBooking={isLoyaltyBooking}
          />
        </>
      )}
    </>
  );
};

JourneyDetailsWithABSADS.propTypes = {
  journey: legShape,
  paxDetails: passengersShape.isRequired,
  direction: PropTypes.string,
  currency: PropTypes.string,
  originUIC: PropTypes.string,
  destinationUIC: PropTypes.string,
  passengers: passengersShape,
  infantCount: PropTypes.number,
  isLoyaltyBooking: PropTypes.bool
};

export default JourneyDetailsWithABSADS;
